/**
 *
 * 모든 페이지들의 URL PATH 상수 리스트
 *
 */

/********** 홈(대시보드) 페이지 URL PATH **********/
export const HOME_URL_PATH = '/';

/********** 로그인 페이지 URL PATH **********/
export const LOGIN_URL_PATH = '/login';

/********** 유저 리스트 페이지 URL PATH **********/
export const ACCOUNT_USER_LIST_URL_PATH = '/account/user/list/all';

/********** 유저 랭크 페이지 URL PATH **********/
export const ACCOUNT_USER_RANK_URL_PATH = '/account/user/rank/all';

/********** 유저 상세 페이지 URL PATH **********/
export const ACCOUNT_USER_DETAIL_URL_PATH = '/account/user/detail/:id';

/********** 판매자 리스트 페이지 URL PATH **********/
export const ACCOUNT_SELLER_LIST_URL_PATH = '/account/seller/list';

/********** 관리자 리스트 페이지 URL PATH **********/
export const ACCOUNT_ADMIN_LIST_URL_PATH = '/account/admin/list';

/********** 관리자 생성 페이지 URL PATH **********/
export const ACCOUNT_ADMIN_CREATE_URL_PATH = '/account/admin/create';

/********** 관리자 조회 페이지 URL PATH **********/
export const ACCOUNT_ADMIN_DETAIL_URL_PATH = '/account/admin/detail/:id';

/********** 관리자 수정 페이지 URL PATH **********/
export const ACCOUNT_ADMIN_EDIT_URL_PATH = '/account/admin/edit/:id';

/********** 입점승인 판매점 리스트 페이지 URL PATH **********/
export const BRAND_JOIN_LIST_URL_PATH = '/store/join/list';

/********** 브랜드 리스트 페이지 URL PATH **********/
export const BRAND_ALL_LIST_URL_PATH = '/store/list/all';

/********** 브랜드 태그 검수 리스트 페이지 URL PATH **********/
export const BRAND_TAG_REQUEST_LIST_URL_PATH = '/store/list/tag/request';

/********** 브랜드 상세 페이지 URL PATH **********/
export const BRAND_DETAIL_URL_PATH = '/store/detail/:id';

/********** 브랜드 티어 관리 페이지 URL PATH **********/
export const BRAND_TIER_URL_PATH = '/store/tier';

/********** 브랜드 상단 노출 관리 페이지 URL PATH **********/
export const BRAND_TOP_EXPOSURE_URL_PATH = '/store/exposure/top';

/********** 브랜드 노출 순서 관리 페이지 URL PATH **********/
export const BRAND_EXPOSURE_URL_PATH = '/store/exposure';

/********** 상품 전체 리스트 페이지 URL PATH **********/
export const PRODUCT_ALL_LIST_URL_PATH = '/product/list/all';

/********** 상품 승인 리스트 페이지 URL PATH **********/
export const PRODUCT_APPROVAL_LIST_URL_PATH = '/product/list/approval';

/********** 상품 금지 리스트 페이지 URL PATH **********/
export const PRODUCT_BAN_LIST_URL_PATH = '/product/list/ban';

/********** 상품 속성 검수 리스트 페이지 URL PATH **********/
export const PRODUCT_PROPERTY_REQUEST_LIST_URL_PATH = '/product/list/property/request';

/********** 상품 등록 페이지 URL PATH **********/
export const PRODUCT_CREATE_URL_PATH = '/product/create';

/********** 상품 등록 페이지 URL PATH **********/
export const PRODUCT_BULK_EDIT_URL_PATH = '/product/bulk/edit';

/********** 상품 편집 페이지 URL PATH **********/
export const PRODUCT_EDIT_URL_PATH = '/product/edit/:id';

/********** 상품 상세 페이지 URL PATH **********/
export const PRODUCT_DETAIL_URL_PATH = '/product/detail/:id';

/********** 상품 복사 페이지 URL PATH **********/
export const PRODUCT_COPY_URL_PATH = '/product/copy/:id';

/********** 상품 버전 페이지 URL PATH **********/
export const PRODUCT_VERSION_URL_PATH = '/product/version/:id';

/********** 주문 전체 리스트 페이지 URL PATH **********/
export const ORDER_ALL_LIST_URL_PATH = '/order/all/list';

/********** 주문 취소 리스트 페이지 URL PATH **********/
export const ORDER_CANCEL_LIST_URL_PATH = '/order/cancel/list';

/********** 주문 반품 리스트 페이지 URL PATH **********/
export const ORDER_RETURN_LIST_URL_PATH = '/order/return/list';

/********** 주문 교환 리스트 페이지 URL PATH **********/
export const ORDER_EXCHANGE_LIST_URL_PATH = '/order/exchange/list';

/********** 주문/배송관리 페이지 URL PATH **********/
export const ORDER_MANAGEMENT_LIST_URL_PATH = '/order/management';

/********** 취소관리 페이지 URL PATH **********/
export const ORDER_CANCEL_MANAGEMENT_URL_PATH = '/order/cancel/management';

/********** 반품관리 페이지 URL PATH **********/
export const ORDER_RETURN_MANAGEMENT_URL_PATH = '/order/return/management';

/********** 교환관리 페이지 URL PATH **********/
export const ORDER_EXCHANGE_MANAGEMENT_URL_PATH = '/order/exchange/management';

/********** 주문 상세 페이지 URL PATH **********/
export const ORDER_DETAIL_URL_PATH = '/order/detail/:id';

/********** 주문 반품 상세 페이지 URL PATH **********/
export const ORDER_RETURN_DETAIL_URL_PATH = '/order/return/detail/:id';

/********** 멀티채널 주문 관리 페이지 URL PATH **********/
export const MULTI_CHANNEL_ORDER_MANAGEMENT_URL_PATH = '/multiChannel/order/management';

/********** 멀티채널 주문 생성 페이지 URL PATH **********/
export const MULTI_CHANNEL_ORDER_CREATE_URL_PATH = '/multiChannel/order/create';

/********** 정산 대기 목록 페이지 URL PATH **********/
export const BALANCE_WAITING_LIST_URL_PATH = '/balance/waiting/list';

/********** 정산 완료 목록 페이지 URL PATH **********/
export const BALANCE_DONE_LIST_URL_PATH = '/balance/done/list';

/********** 정산 보류 목록 페이지 URL PATH **********/
export const BALANCE_HOLD_LIST_URL_PATH = '/balance/hold/list';

/********** 정산 수행 페이지 URL PATH **********/
export const BALANCE_EXECUTION_URL_PATH = '/balance/execution/:id';

/********** 정산 브랜드 목록 페이지 URL PATH **********/
export const BALANCE_BRAND_LIST_URL_PATH = '/balance/brand/list';

/********** 정산 기준일 변경 페이지 URL PATH **********/
export const BALANCE_ADJUSTMENT_BASE_DATE_URL_PATH = '/balance/adjustment/base-date';

/********** 정산 완료일 변경 페이지 URL PATH **********/
export const BALANCE_ADJUSTMENT_COMPLETE_DATE_URL_PATH = '/balance/adjustment/complete-date';

/********** 결제 PG 라우팅 페이지 URL PATH **********/
export const PAYMENT_PG_ROUTE_URL_PATH = '/payment/pg-route';

/********** PG 수수료 관리 페이지 URL PATH **********/
export const PAYMENT_PG_FEE_URL_PATH = '/payment/pg-fee';

/********** 태그 등록 페이지 URL PATH **********/
export const TAG_CREATE_URL_PATH = '/tag/create';

/********** 태그 편집 페이지 URL PATH **********/
export const TAG_EDIT_URL_PATH = '/tag/edit/:id';

/********** 태그 상세 내역 페이지 URL PATH **********/
export const TAG_HISTORY_URL_PATH = '/tag/history/:id';

/********** 태그 리스트 페이지 URL PATH **********/
export const TAG_LIST_URL_PATH = '/tag/list';

/********** 태그 그룹 등록 페이지 URL PATH **********/
export const TAG_GROUP_CREATE_URL_PATH = '/tag/group/create';

/********** 태그 그룹 편집 페이지 URL PATH **********/
export const TAG_GROUP_EDIT_URL_PATH = '/tag/group/edit/:id';

/********** 태그 그룹 리스트 페이지 URL PATH **********/
export const TAG_GROUP_LIST_URL_PATH = '/tag/group/list';

/********** 태그 탭 메인 관리 페이지 URL PATH **********/
export const TAG_TAB_MAIN_MANAGEMENT_URL_PATH = '/tag/management/tab/main';

/********** 태그 트렌드 키워드 관리 페이지 URL PATH **********/
export const TAG_TREND_KEYWORD_MANAGEMENT_URL_PATH = '/tag/management/trend/keyword';

/********** 프로모션 스케줄 타임라인 페이지 URL PATH **********/
export const PROMOTION_SCHEDULE_URL_PATH = '/promotion/schedule';
/**
 * ⚠️ `list` 와 `:id` 가 **같은 깊이**다. 라우트 등록에서 `list` 를 먼저 두지 않으면
 * `/promotion/schedule/list` 가 id 로 해석돼 리스트 화면이 통째로 안 열린다.
 * (백엔드도 같은 함정이 있어 `@Get('list')` 를 `@Get(':id')` 앞에 선언했다 — AMZBM-110)
 */
export const PROMOTION_SCHEDULE_LIST_URL_PATH = '/promotion/schedule/list';
export const PROMOTION_SCHEDULE_DETAIL_URL_PATH = '/promotion/schedule/:id';

/********** 홈에 노출중인 기획전 리스트 페이지 URL PATH **********/
export const EVENT_IN_PROGRESS_LIST_URL_PATH = '/event/inProgress/list';

/********** 기획전 전체 리스트 페이지 URL PATH **********/
export const EVENT_ALL_LIST_URL_PATH = '/event/all/list';

/********** 기획전 등록 페이지 URL PATH **********/
export const EVENT_CREATE_URL_PATH = '/event/create';

/********** 기획전 편집 페이지 URL PATH **********/
export const EVENT_EDIT_URL_PATH = '/event/edit/:id';

/********** 쿠폰 리스트 페이지 URL PATH **********/
export const COUPON_LIST_URL_PATH = '/coupon/list';

/********** 쿠폰 발급 페이지 URL PATH **********/
export const COUPON_GENERATE_URL_PATH = '/coupon/generate';

/********** 쿠폰 발급 내역 리스트 페이지 URL PATH **********/
export const COUPON_ISSUE_HISTORY_LIST_URL_PATH = '/coupon/issueHistory/list';

/********** 쿠폰 발급 내역 상세 페이지 URL PATH **********/
export const COUPON_ISSUE_HISTORY_DETAIL_URL_PATH = '/coupon/issueHistory/detail/:id';

/********** 쿠폰 편집 페이지 URL PATH **********/
export const COUPON_EDIT_URL_PATH = '/coupon/edit/:id';

/********** 쿠폰 복사 페이지 URL PATH **********/
export const COUPON_COPY_URL_PATH = '/coupon/copy/:id';

/********** 쿠폰 상세 페이지 URL PATH **********/
export const COUPON_DETAIL_URL_PATH = '/coupon/detail/:id';

/********** 쿠폰 등록 페이지 URL PATH **********/
export const COUPON_CREATE_URL_PATH = '/coupon/create';

/********** 알림톡 발송 등록 페이지 URL PATH **********/
export const ALIMTALK_SEND_CREATE_URL_PATH = '/alimtalk/send/create';

/********** 알림톡 발송 내역 리스트 페이지 URL PATH **********/
export const ALIMTALK_SEND_HISTORY_LIST_URL_PATH = '/alimtalk/send/history/list';

/********** 알림톡 발송 내역 상세 페이지 URL PATH **********/
export const ALIMTALK_SEND_HISTORY_DETAIL_URL_PATH = '/alimtalk/send/history/detail/:id';

/********** 포인트 내역 리스트 페이지 URL PATH **********/
export const POINT_LIST_URL_PATH = '/point/list';
/********** 포인트 발급 페이지 URL PATH **********/
export const POINT_GENERATE_URL_PATH = '/point/generate';
/********** 포인트 발급 내역 리스트 페이지 URL PATH **********/
export const POINT_ISSUE_HISTORY_LIST_URL_PATH = '/point/issueHistory/list';
/********** 포인트 발급 내역 상세 페이지 URL PATH **********/
export const POINT_ISSUE_HISTORY_DETAIL_URL_PATH = '/point/issueHistory/detail/:id';
/********** 포인트 랭킹 페이지 URL PATH **********/
export const POINT_RANKING_LIST_URL_PATH = '/point/ranking/list';
/********** 포인트 레퍼럴 발급 현황 URL PATH **********/
export const POINT_REFERRAL_ISSUE_LIST_URL_PATH = '/point/referralIssue/list';
/********** 포인트 사유 리스트 페이지 URL PATH **********/
export const POINT_CAUSE_LIST_URL_PATH = '/point/cause/list';
/********** 포인트 사유 등록 페이지 URL PATH **********/
export const POINT_CAUSE_CREATE_URL_PATH = '/point/cause/create';

/********** 메인 페이지 관리 페이지 URL PATH **********/
export const MAIN_PAGE_MANAGEMENT_URL_PATH = '/home/main/management';

/********** 홈 메인 탭 관리 페이지 URL PATH **********/
export const MAIN_TAB_MANAGEMENT_URL_PATH = '/home/tab/management';

/********** 서브 페이지 리스트 페이지 URL PATH **********/
export const SUB_PAGE_LIST_URL_PATH = '/home/sub/list';

/********** 서브 페이지 등록 페이지 URL PATH **********/
export const SUB_PAGE_CREATE_URL_PATH = '/home/sub/create';

/********** 서브 페이지 관리 페이지 URL PATH **********/
export const SUB_PAGE_MANAGEMENT_URL_PATH = '/home/sub/management/:id';

/********** 서브 페이지 편집 페이지 URL PATH **********/
export const SUB_PAGE_EDIT_URL_PATH = '/home/sub/edit/:id';

/********** 위젯 전체 리스트 페이지 URL PATH **********/
export const WIDGET_ALL_LIST_URL_PATH = '/home/widget/all/list';

/********** 위젯 생성 페이지 URL PATH **********/
export const WIDGET_CREATE_URL_PATH = '/home/widget/create';

/********** 위젯 홈 메뉴 생성 페이지 URL PATH **********/
export const WIDGET_HOME_MENU_CREATE_URL_PATH = '/home/homeMenu/create';

/********** 위젯 편집 페이지 URL PATH **********/
export const WIDGET_EDIT_URL_PATH = '/home/widget/edit/:id';

/********** 위젯 복사 페이지 URL PATH **********/
export const WIDGET_COPY_URL_PATH = '/home/widget/copy/:id';

/********** 카테고리 생성 관리 페이지 URL PATH **********/
export const CATEGORY_CREATE_MANAGEMENT_URL_PATH = '/categories';

/********** 카테고리 상세 페이지 URL PATH **********/
export const CATEGORY_DETAIL_URL_PATH = '/categories/:id';

/********** 카테고리 생성 페이지 URL PATH **********/
export const CATEGORY_CREATE_URL_PATH = '/category/create';

/********** 카테고리 전시 관리 페이지 URL PATH **********/
export const CATEGORY_EXHIBIT_MANAGEMENT_URL_PATH = '/categories/exhibition';

/********** 스플래시 이미지 리스트 페이지 URL PATH **********/
export const REMOTE_SPLASH_IMAGE_LIST_URL_PATH = '/remoteImage/splash/list';

/********** 스플래시 이미지 등록 페이지 URL PATH **********/
export const REMOTE_SPLASH_IMAGE_CREATE_URL_PATH = '/remoteImage/splash/create';

/********** 스플래시 이미지 수정 페이지 URL PATH **********/
export const REMOTE_SPLASH_IMAGE_EDIT_URL_PATH = '/remoteImage/splash/edit/:id';

/********** 레퍼럴 이미지 리스트 페이지 URL PATH **********/
export const REMOTE_REFERRAL_IMAGE_LIST_URL_PATH = '/remoteImage/referral/list';

/********** 레퍼럴 이미지 등록 페이지 URL PATH **********/
export const REMOTE_REFERRAL_IMAGE_CREATE_URL_PATH = '/remoteImage/referral/create';

/********** 레퍼럴 이미지 수정 페이지 URL PATH **********/
export const REMOTE_REFERRAL_IMAGE_EDIT_URL_PATH = '/remoteImage/referral/edit/:id';

/********** 상점 공지사항 리스트 페이지 URL PATH **********/
export const NOTICE_STORE_LIST_URL_PATH = '/notice/store/list';

/********** 상점 공지사항 등록 페이지 URL PATH **********/
export const NOTICE_STORE_CREATE_URL_PATH = '/notice/store/create';

/********** 상점 공지사항 편집 페이지 URL PATH **********/
export const NOTICE_STORE_EDIT_URL_PATH = '/notice/store/edit/:id';

/********** 상품 공지사항 리스트 페이지 URL PATH **********/
export const NOTICE_PRODUCT_LIST_URL_PATH = '/notice/product/list';

/********** 상품 공지사항 상세 페이지 URL PATH **********/
export const NOTICE_PRODUCT_DETAIL_URL_PATH = '/notice/product/detail/:id';

/********** 검색 키워드 리스트 페이지 URL PATH **********/
export const SEARCH_WORD_LIST_URL_PATH = '/searchWord/list';

/********** 검색 키워드 등록 페이지 URL PATH **********/
export const SEARCH_WORD_CREATE_URL_PATH = '/searchWord/create';

/********** 검색 키워드 등록 페이지 URL PATH **********/
export const SEARCH_WORD_EDIT_URL_PATH = '/searchWord/edit/:id';

/********** 검색 사전 페이지 URL PATH (AMZUWEB-694) — 동의어 · 사용자사전 · 변경 이력 탭 **********/
export const SEARCH_DICTIONARY_URL_PATH = '/search/dictionary';

/********** 검색 사전 동의어 규칙 등록 페이지 URL PATH **********/
export const SEARCH_DICTIONARY_SYNONYM_CREATE_URL_PATH = '/search/dictionary/synonyms/new';

/********** 검색 사전 동의어 규칙 상세 페이지 URL PATH **********/
export const SEARCH_DICTIONARY_SYNONYM_DETAIL_URL_PATH = '/search/dictionary/synonyms/:id';

/********** 1:1 문의 리스트 페이지 URL PATH **********/
export const CS_INQUIRY_LIST_URL_PATH = '/cs/inquiry/list';

/********** 1:1 문의 상세 페이지 URL PATH **********/
export const CS_INQUIRY_DETAIL_URL_PATH = '/cs/inquiry/detail/:id';

/********** 상품 문의 리스트 페이지 URL PATH **********/
export const CS_QNA_LIST_URL_PATH = '/cs/qna/list';

/********** 상품 문의 상세 페이지 URL PATH **********/
export const CS_QNA_DETAIL_URL_PATH = '/cs/qna/detail/:id';

/********** 상품 후기 리스트 페이지 URL PATH **********/
export const CS_REVIEW_LIST_URL_PATH = '/cs/review/list';

/********** 상품 후기 상세 페이지 URL PATH **********/
export const CS_REVIEW_DETAIL_URL_PATH = '/cs/review/detail/:id';

/********** 상품 후기 등록 페이지 URL PATH **********/
export const CS_REVIEW_CREATE_URL_PATH = '/cs/review/create';

/********** 버전 전체 리스트 페이지 URL PATH **********/
export const VERSION_LIST_URL_PATH = '/version/list';
/********** 버전 등록 페이지 URL PATH **********/
export const VERSION_CREATE_URL_PATH = '/version/create';
/********** 버전 편집 페이지 URL PATH **********/
export const VERSION_EDIT_URL_PATH = '/version/edit/:id';

/********** 추천 상품 리스트 페이지 URL PATH **********/
export const RECOMMEND_PRODUCT_LIST_URL_PATH = '/recommend/product/list';

/********** 추천 상품 상세 페이지 URL PATH **********/
export const RECOMMEND_PRODUCT_DETAIL_URL_PATH = '/recommend/product/detail/:id';

/********** 추천 상품 복사 페이지 URL PATH **********/
export const RECOMMEND_PRODUCT_COPY_URL_PATH = '/recommend/product/copy/:id';

/********** 추천 상품 등록 페이지 URL PATH **********/
export const RECOMMEND_PRODUCT_CREATE_URL_PATH = '/recommend/product/create';

/********** 추천 상품 후기 리스트 페이지 URL PATH **********/
export const RECOMMEND_REVIEW_LIST_URL_PATH = '/recommend/review/list';

/********** 추천 상품 후기 상세 페이지 URL PATH **********/
export const RECOMMEND_REVIEW_DETAIL_URL_PATH = '/recommend/review/detail/:id';

/********** 추천 상품 후기 복사 페이지 URL PATH **********/
export const RECOMMEND_REVIEW_COPY_URL_PATH = '/recommend/review/copy/:id';

/********** 추천 상품 후기 등록 페이지 URL PATH **********/
export const RECOMMEND_REVIEW_CREATE_URL_PATH = '/recommend/review/create';

/********** 추천 태그 리스트 페이지 URL PATH **********/
export const RECOMMEND_TAG_LIST_URL_PATH = '/recommend/tag/list';

/********** 추천 태그 상세 페이지 URL PATH **********/
export const RECOMMEND_TAG_DETAIL_URL_PATH = '/recommend/tag/detail/:id';

/********** 추천 태그 복사 페이지 URL PATH **********/
export const RECOMMEND_TAG_COPY_URL_PATH = '/recommend/tag/copy/:id';

/********** 추천 태그 등록 페이지 URL PATH **********/
export const RECOMMEND_TAG_CREATE_URL_PATH = '/recommend/tag/create';

/********** 추천 검색 키워드 리스트 페이지 URL PATH **********/
export const RECOMMEND_SEARCH_WORD_LIST_URL_PATH = '/recommend/searchWord/list';

/********** 추천 검색 키워드 상세 페이지 URL PATH **********/
export const RECOMMEND_SEARCH_WORD_DETAIL_URL_PATH = '/recommend/searchWord/detail/:id';

/********** 추천 검색 키워드 복사 페이지 URL PATH **********/
export const RECOMMEND_SEARCH_WORD_COPY_URL_PATH = '/recommend/searchWord/copy/:id';

/********** 추천 검색 키워드 등록 페이지 URL PATH **********/
export const RECOMMEND_SEARCH_WORD_CREATE_URL_PATH = '/recommend/searchWord/create';

/********** 추천 기획전 리스트 페이지 URL PATH **********/
export const RECOMMEND_EVENT_LIST_URL_PATH = '/recommend/event/list';

/********** 추천 기획전 상세 페이지 URL PATH **********/
export const RECOMMEND_EVENT_DETAIL_URL_PATH = '/recommend/event/detail/:id';

/********** 추천 기획전 복사 페이지 URL PATH **********/
export const RECOMMEND_EVENT_COPY_URL_PATH = '/recommend/event/copy/:id';

/********** 추천 기획전 등록 페이지 URL PATH **********/
export const RECOMMEND_EVENT_CREATE_URL_PATH = '/recommend/event/create';

/********** 추천 상점 리스트 페이지 URL PATH **********/
export const RECOMMEND_STORE_LIST_URL_PATH = '/recommend/store/list';

/********** 추천 상점 상세 페이지 URL PATH **********/
export const RECOMMEND_STORE_DETAIL_URL_PATH = '/recommend/store/detail/:id';

/********** 추천 상점 복사 페이지 URL PATH **********/
export const RECOMMEND_STORE_COPY_URL_PATH = '/recommend/store/copy/:id';

/********** 추천 상점 등록 페이지 URL PATH **********/
export const RECOMMEND_STORE_CREATE_URL_PATH = '/recommend/store/create';

/**
 * 응모하기
 */
export const LUCKY_DRAW_URL_PATH = '/luckyDraws';

/********** 아몬즈 서비스 리스트 페이지 URL PATH **********/
export const SERVICE_LIST = '/service/list';

/********** 잠못된 요청 **********/
export const INVALID_REQUEST_URL_PATH = '/invalid';

/********** 권한외 요청 **********/
export const UNAUTHORIZED_REQUEST_URL_PATH = '/unauthorized';
